"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.create.title': '创建新问题',
};
